import Admin from "./Admin.container";
export default Admin;
